import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs as ToolkitBreadcrumbs } from '@quantum-ecosystem/ui-toolkit';

export const FormBreadcrumbs = ({
	children,
	separator = '→',
	className,
	...restProps
}) => {
	return (
		<ToolkitBreadcrumbs
			separator={separator}
			className={className}
			{...restProps}
		>
			{children}
		</ToolkitBreadcrumbs>
	);
};

FormBreadcrumbs.propTypes = {
	children: PropTypes.node,
	separator: PropTypes.node,
	className: PropTypes.string,
};

export default FormBreadcrumbs;
